import InternalLink from '../../components/link/internal-link';
import OneAppProfileLink from '../../components/link/one-app-profile-link';
import { BLOG_APP_ID } from '@wix/communities-universal/dist/src/constants/appsConfig';
import { MEMBER_DRAFTS_ID } from '@wix/communities-blog-client-common/dist/src/constants/component-ids';
import { navigateToBlog } from '../navigate-to-section';
import forUserPrivacyType from '../for-user-privacy-type';
import { debug } from '../debug';
import Wix from '../wix-sdk-polyfill';

export default {
  Link: InternalLink,
  ProfileLink: forUserPrivacyType(OneAppProfileLink),
  navigateToCreatePost: navigateToBlog,
  navigateToEditPost: navigateToBlog,

  // This doesn't work in the web.
  // navigateToSection is used only because this is how one app tabs currently work.
  navigateToDrafts: () =>
    Wix.Utils.navigateToSection(
      {
        appDefinitionId: BLOG_APP_ID,
        sectionId: MEMBER_DRAFTS_ID,
        shouldRefreshIframe: false,
      },
      '',
      debug.error,
    ),
};
